// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-modal .MuiDialog-paper {
    border-radius: 8px;
    box-shadow: 0 4px 18px rgba(0, 0, 0, 0.1);
}

.flag-icon {
    width: 20px;
    height: 14px;
    margin-right: 8px;
    vertical-align: middle;
}

.MuiTabs-root {
    background-color: #f7f7f7;
    border-bottom: 1px solid #ddd;
}

.MuiDialogContent-root {
    padding: 24px;
}

.MuiDialogActions-root {
    padding: 16px 24px;
    justify-content: space-between;
}

@media (max-width: 768px) {
    .MuiGrid-item {
        flex-basis: 100% !important;
        max-width: 100% !important;
    }
}
.modal-box {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #fff;
    width: 90%;
    max-width: 800px;
    padding: 20px;
    border-radius: 8px;
    outline: none;
    box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    max-height: 90vh;
    overflow-y: auto;
}

.tab-content {
    margin-top: 20px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
}

.flag-option {
    display: flex;
    align-items: center;
    gap: 8px;
}

.flag-icon {
    width: 20px;
    height: 15px;
    border-radius: 2px;
}

.dropdown-wrapper {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.modal-actions {
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
}
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(60, 60, 60, 0.4);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2000;
}

.modal-container {
    background: #fff;
    border-radius: 8px;
    width: 95%;
    max-width: 1400px;
    max-height: 90%;
    overflow-y: auto;
    padding: 24px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
}

.tabs {
    display: flex;
    gap: 10px;
    margin-bottom: 20px;
    flex-wrap: wrap;
}

.tab-btn {
    padding: 10px 18px;
    background: #000000;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 8px;
}

    .tab-btn.active {
        background: #004080;
        color: white;
    }

.form-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
    gap: 16px;
}

.form-group {
    display: flex;
    flex-direction: column;
}

    .form-group label {
        font-size: 14px;
        margin-bottom: 4px;
    }

.modal-actions {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 20px;
}

.cancel-btn,
.add-btn {
    padding: 10px 18px;
    border: none;
    border-radius: 4px;
    font-weight: 600;
    cursor: pointer;
}

.cancel-btn {
    background: #ddd;
}

.add-btn {
    background: #004080;
    color: white;
}

.flag-icon {
    width: 18px;
    height: 14px;
    margin-right: 6px;
    vertical-align: middle;
}
`, "",{"version":3,"sources":["webpack://./src/pages/demo/Stowage/AddContainerRowModal.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,yCAAyC;AAC7C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI;QACI,2BAA2B;QAC3B,0BAA0B;IAC9B;AACJ;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,gBAAgB;IAChB,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,yCAAyC;IACzC,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,8BAA8B;AAClC;AACA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,iCAAiC;IACjC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;IAEI;QACI,mBAAmB;QACnB,YAAY;IAChB;;AAEJ;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;IAEI;QACI,eAAe;QACf,kBAAkB;IACtB;;AAEJ;IACI,aAAa;IACb,yBAAyB;IACzB,SAAS;IACT,gBAAgB;AACpB;;AAEA;;IAEI,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,sBAAsB;AAC1B","sourcesContent":[".container-modal .MuiDialog-paper {\n    border-radius: 8px;\n    box-shadow: 0 4px 18px rgba(0, 0, 0, 0.1);\n}\n\n.flag-icon {\n    width: 20px;\n    height: 14px;\n    margin-right: 8px;\n    vertical-align: middle;\n}\n\n.MuiTabs-root {\n    background-color: #f7f7f7;\n    border-bottom: 1px solid #ddd;\n}\n\n.MuiDialogContent-root {\n    padding: 24px;\n}\n\n.MuiDialogActions-root {\n    padding: 16px 24px;\n    justify-content: space-between;\n}\n\n@media (max-width: 768px) {\n    .MuiGrid-item {\n        flex-basis: 100% !important;\n        max-width: 100% !important;\n    }\n}\n.modal-box {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    background: #fff;\n    width: 90%;\n    max-width: 800px;\n    padding: 20px;\n    border-radius: 8px;\n    outline: none;\n    box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);\n    max-height: 90vh;\n    overflow-y: auto;\n}\n\n.tab-content {\n    margin-top: 20px;\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 16px;\n}\n\n.flag-option {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.flag-icon {\n    width: 20px;\n    height: 15px;\n    border-radius: 2px;\n}\n\n.dropdown-wrapper {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n}\n\n.modal-actions {\n    margin-top: 20px;\n    display: flex;\n    justify-content: space-between;\n}\n.modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(60, 60, 60, 0.4);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 2000;\n}\n\n.modal-container {\n    background: #fff;\n    border-radius: 8px;\n    width: 95%;\n    max-width: 1400px;\n    max-height: 90%;\n    overflow-y: auto;\n    padding: 24px;\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);\n}\n\n.tabs {\n    display: flex;\n    gap: 10px;\n    margin-bottom: 20px;\n    flex-wrap: wrap;\n}\n\n.tab-btn {\n    padding: 10px 18px;\n    background: #000000;\n    border: none;\n    border-radius: 6px;\n    cursor: pointer;\n    font-weight: 500;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n    .tab-btn.active {\n        background: #004080;\n        color: white;\n    }\n\n.form-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));\n    gap: 16px;\n}\n\n.form-group {\n    display: flex;\n    flex-direction: column;\n}\n\n    .form-group label {\n        font-size: 14px;\n        margin-bottom: 4px;\n    }\n\n.modal-actions {\n    display: flex;\n    justify-content: flex-end;\n    gap: 12px;\n    margin-top: 20px;\n}\n\n.cancel-btn,\n.add-btn {\n    padding: 10px 18px;\n    border: none;\n    border-radius: 4px;\n    font-weight: 600;\n    cursor: pointer;\n}\n\n.cancel-btn {\n    background: #ddd;\n}\n\n.add-btn {\n    background: #004080;\n    color: white;\n}\n\n.flag-icon {\n    width: 18px;\n    height: 14px;\n    margin-right: 6px;\n    vertical-align: middle;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
